import { forceHttps } from 'utils/strings/slugs';

const isTransformableCloudinaryUrl = (url: string): boolean =>
  !url.toLowerCase().endsWith('.svg') && !url.includes('image/svg+xml') && url.includes('res.cloudinary.com');

// Used for CSS background-image URLs that bypass next/image. Applies
// f_auto so modern browsers receive WebP/AVIF, keeps quality lossless
// (q_100), and caps width so the source PNG is not delivered at 4-6x
// the size it needs.
export const buildBackgroundUrl = (rawUrl: string | undefined | null, maxWidth = 2400): string | undefined => {
  if (!rawUrl) {
    return undefined;
  }

  const url = forceHttps(rawUrl) || rawUrl;

  if (!isTransformableCloudinaryUrl(url)) {
    return url;
  }

  const parts = url.split('/');
  const uploadIndex = parts.indexOf('upload') + 1;
  if (uploadIndex === 0) {
    return url;
  }

  const params = ['f_auto', 'q_100', `w_${maxWidth}`, 'c_limit', 'fl_progressive', 'fl_immutable_cache'];
  parts.splice(uploadIndex, 0, params.join(','));

  return parts.join('/');
};
